import { render, staticRenderFns } from "./ReportesActividades.vue?vue&type=template&id=164e61c4&scoped=true"
import script from "./ReportesActividades.vue?vue&type=script&lang=js"
export * from "./ReportesActividades.vue?vue&type=script&lang=js"
import style0 from "./ReportesActividades.vue?vue&type=style&index=0&id=164e61c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e61c4",
  null
  
)

export default component.exports